const CodeDocs = [
    {
        title: 'Land Banks',
        url: 'https://www.google.com'
    },
    {
        title: 'Group Insurance for Public Employees',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_8d66f68d33be447ab73a355555ad5d90.pdf'
    },
    {
        title: 'Public Meetings',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_ccb0b13d9408482a8f2f5e2ca37c9b20.pdf'
    },
    {
        title: 'Access to Public Records',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_fcce790e07044e579b64882368bdb204.pdf'
    },
    {
        title: 'Exemptions',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_c9a3032ee794487d8dada0da745b5471.pdf'
    },
    {
        title: 'Sale of Real Property When Taxes or Special Assessments Become Delinquent',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_a48cf24338004185928aa0b135ffe1f2.pdf'
    },
    {
        title: 'Redemption of and Tax Deeds for Real Property Sold for Delinquent Taxes and Special Assessments ',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_b89db7c50ca145e0af1ac1d65a428471.pdf'
    },
    {
        title: 'Business and Other Associations',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_d77d7c4da2aa417cb0ddd4e2975f1da9.pdf'
    },
    {
        title: 'Interlocal Cooperation​',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_93ae4f951fdf44d5ab0501bbcc329791.pdf'
    },
    {
        title: 'Disposal of Real or Personal Property',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_9effedf687db4df8b243c5eeba7185b4.pdf'
    },
    {
        title: 'Unsafe Building Law',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_806f061f5b514b76af9ec0d62bb7b675.pdf'
    },
    {
        title: 'Participation by Political Subdivisions',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_f873f900ab36455ea719e26df9422088.pdf'
    },
    {
        title: 'Group Insurance for Public Employees',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_8d66f68d33be447ab73a355555ad5d90.pdf'
    }
];
const ImportantDocs = [
    {
        title: 'Letters of Support',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_9fa7ad934f4d4e95aa9ec8711a0cb774.pdf'
    },
    {
        title: 'Articles of Incorporation',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_159e08604f1843c3ba8b4d3691259c5d.pdf'
    },
    {
        title: 'Mission Statement',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_9a374772433e454fa9831e25eefa7be3.pdf'
    },
    {
        title: 'MLB 2020 Annual/Financial Report',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_f6a5dc4a33814dc79ae90be095876645.pdf'
    },
    {
        title: 'IRS 501(c)(3) Designation',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_ed7b2f54384246d48b0195c0297275bb.pdf'
    },
    {
        title: 'MLB By-Laws',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_6edebba396e7408391ca8d042c896d6f.pdf'
    }
];
const PolicyDocs = [
    {
        title: 'Poperty Acquisition Policy',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_1aeef274086b4e66bc24dfd422f124d4.pdf'
    },
    {
        title: 'Property Maintenance Policy',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_8643a10347874686a6a4d32e77b1d27d.pdf'
    },
    {
        title: 'Property Disposition Policy',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_f799f9d86caa48b6aa358c4d69833179.pdf'
    },
    {
        title: 'Fiscal Actions &amp; Operations Policy',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_5f824d32fcec4d0fb82bced0b25df990.pdf'
    },
    {
        title: 'Comprehensive Conflict &amp; Ethics Policy',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/fa18a9_1d8d5edc7eca4538bc67c74cca86acc5.pdf'
    }
];

export { CodeDocs, ImportantDocs, PolicyDocs };
